import Spinner from '@ancon/wildcat-ui/web/orderweb/Spinner'
import '@ancon/wildcat-ui/web/orderweb/Spinner/Spinner.css'

export default Spinner
